import { tk } from '@/i18n/translationKeys';
import { PaymentState, PaymentEnum } from '@/generated/types';
import { FilterTagOption, FilterType } from './types';

export interface FiltersOptions {
  filterOptions: FilterTagOption[];
  statusOptions: FilterTagOption[];
  paymentTypeOptions: FilterTagOption[];
}

export const getFiltersOptions = (
  t: (key: string) => string,
  isBusinessUser: boolean
): FiltersOptions => {
  const filterOptions = [
    {
      label: t(tk.yourPaymentsFilterTitleDevice),
      value: FilterType.Device,
    },
    {
      label: t(tk.yourPaymentsListTitleStatus),
      value: FilterType.Status,
    },
    {
      label: t(tk.yourPaymentsFilterTitlePaymentType),
      value: FilterType.PaymentType,
    },
  ];

  const businessFilterOptions = filterOptions.filter(
    (option) => option.value !== FilterType.Device
  );

  const statusOptions = [
    {
      label: t(tk.yourPaymentsStatePaid),
      value: PaymentState.PAID,
    },
    {
      label: t(tk.yourPaymentsStateScheduled),
      value: PaymentState.SCHEDULED,
    },
    {
      label: t(tk.yourPaymentsStateFailed),
      value: PaymentState.FAILED,
    },
    {
      label: t(tk.yourPaymentsStateCanceled),
      value: 'CANCELED',
    },
  ];

  const paymentTypeOptions = [
    {
      label: t(tk.yourPaymentsTypePurchaseText),
      value: PaymentEnum.PURCHASE_PAYMENT,
    },
    {
      label: t(tk.yourPaymentsTypeSubscriptionText),
      value: PaymentEnum.SUBSCRIPTION_PAYMENT,
    },
    {
      label: t(tk.yourPaymentsTypeOrderText),
      value: PaymentEnum.ORDER_PAYMENT,
    },
  ];

  return {
    filterOptions: isBusinessUser ? businessFilterOptions : filterOptions,
    statusOptions,
    paymentTypeOptions,
  };
};
